var AT_Filter = window.AT_Filter || {};

(function($) {
	AT_Filter = {

		init: function () {
			this.filterElem = $(".grid-uniform");
			this.isLoading = false;
			this.updateURL = false;
			this.requestAgain = false;
      this.title;
      this.addEvent();

      if( this.filterElem.length > 0 ) {
				// Bind to StateChange Event
			    History.Adapter.bind(window,'statechange',function(){ // Note: We are using statechange instead of popstate
			        var State = History.getState(); // Note: We are using History.getState() instead of event.state;
			        AT_Filter.updateURL = false;
			        if(AT_Filter.requestAgain)
			        	AT_Filter.requestPage(State.data.url);
			       	AT_Filter.requestAgain = true;
			    });
			}
		},

		addEvent: function() {
			//prevent li clicked
			AT_Filter.filterElem.on("click", ".advanced-filter", function(event){
				return false;
			});

			AT_Filter.filterElem.on("click", ".advanced-filter a", function(e){
				if (AT_Filter.isLoading) {
					return;
				}
        if ($(this).attr('href') == 'javascript:void(0);') {return}
				var target = $(e.currentTarget), href;

				href = target.attr("href");
				// Allow multiple filter selections - the server response will update the filter states correctly
				// We don't need to toggle classes here as the AJAX response replaces the filter list with correct states
        jQuery(this).parents('.sbw-filter').first().addClass('waiting');
				AT_Filter.updateURL = true;
				AT_Filter.requestPage(href);
				// jQuery("#page-body").trigger('click');
				return false;

			});
          //Click on pager
      $(document).on('click', '.srp-filter-wrapper .advanced-filter a', function(e){
      	if (AT_Filter.isLoading) {
          return;
        }

        var target = $(e.currentTarget), href;
        if( target.parent().hasClass('active') )
        	return;

        href = target.attr("href");
        AT_Filter.updateURL = true;
        AT_Filter.requestPage(href);
        return false;
      });

      $(document).on('click','.sort-by li.sort-action',function(e){
        $('#cata_sort_by').addClass('waiting');
        if (AT_Filter.isLoading) {
         return;
       }

			$('.sort-action').removeClass('active');
        var href;
        $('.sort-by .name').html($(this).html());

        if(!$(this).hasClass('active')){
        	$(this).addClass('active');
          var value = jQuery(this).attr('data-sort');

          jQuery('.select-sort option').each(function(){
            jQuery(this).val() == value && jQuery(this).prop('selected',true);
          })

          Shopify.queryParams.sort_by = value;
          delete Shopify.queryParams.page;
          href = '?'+jQuery.param(Shopify.queryParams);
          //location.search = jQuery.param(Shopify.queryParams);
          AT_Filter.updateURL = true;
          AT_Filter.requestPage(href);
        }
      });

      $('.select-sort').on('change', function(e) {
      	let value = $(this).val();

      	$('#sort_by_box li').removeClass('active');
        $('#sort_by_box li[data-sort='+value+']').addClass('active');
        $('.sort-by .name').html($('#sort_by_box li[data-sort='+value+']').html());

        Shopify.queryParams.sort_by = value;
        delete Shopify.queryParams.page;
        href = '?'+jQuery.param(Shopify.queryParams)
        AT_Filter.updateURL = true;
        AT_Filter.requestPage(href);
      })
		},

		requestPage: function(href) {
			$('.new-loading').addClass('loading');
			if (history.pushState) {
				this.getPage(href);
			} else {
				location.assign(href);
			}
		},

		filterPage: function(href){
			var splitArr = [],  param;
            if(String(href).indexOf("/") != -1) {
              splitArr = href.split("/");
              param = splitArr[splitArr.length - 1];
            }
            else
              param = href;
			// console.log(param)
			return param;
		},

		getPage: function(href) {
			this.isLoading = true;
			jQuery.ajax({
        url: href,
        complete:function(){
          jQuery('.sbw-filter,#cata_sort_by').removeClass('waiting');
        },
        success: function (response)
        {
          var _obj = $(response);
          
          let _tagArray = _obj.filter(i=>{return _obj[i].nodeName.toLowerCase() === 'title';});
          AT_Filter.title = _tagArray[0];

          if(AT_Filter.updateURL) {
           var params = AT_Filter.filterPage(href);
           AT_Filter.updateURL = false;
           AT_Filter.requestAgain = false;

           History.pushState( {url: href}, AT_Filter.title.innerHTML,  href );

          }
          AT_Filter.isLoading = false;

          $("#col-main").empty().append(_obj.find("#col-main").children());
          $("#prod-show").empty().append(_obj.find("#prod-show").html());
          $(".pagination-holder").empty().append(_obj.find(".pagination-holder").html());

          if (_obj.find(".load_more").length) {
          $(".load_more").empty().append(_obj.find(".load_more").html());
          $(".load_more").show();
          }else{
          $(".load_more").hide();
          }
          AT_Filter.filterElem.each(function(){
          	var sel = ".sb-filter." + $(this).data('prefix')
              ,filter_list = _obj.find(sel);
          	$(this).empty().append(filter_list);
          });
          
          // Update variant size filter separately (it has a different structure for sidebar)
          // The AJAX response contains the full page HTML, so we need to find the filter in the sidebar
          var variantSizeFilterNew = _obj.find('.variant-size-filter');
          
          if (variantSizeFilterNew.length > 0) {
            var $currentFilter = $('.variant-size-filter');
            
            if ($currentFilter.length > 0) {
              var $newFilter = variantSizeFilterNew.first();
              
              // For sidebar (sb-tag), replace the containers but keep the widget structure
              if ($currentFilter.hasClass('sb-tag')) {
                // Remove old containers
                $currentFilter.find('.variant-size-active-container, .variant-size-inactive-container').remove();
                // Clone new containers from response
                var $newActiveContainer = $newFilter.find('.variant-size-active-container');
                var $newInactiveContainer = $newFilter.find('.variant-size-inactive-container');
                
                // Add new containers after the title
                var $title = $currentFilter.find('p.sb-title.h4, p.h4').first();
                if ($title.length > 0) {
                  if ($newActiveContainer.length > 0) {
                    $title.after($newActiveContainer.clone());
                  }
                  if ($newInactiveContainer.length > 0) {
                    // Find where to insert - after active container or after title
                    var $lastContainer = $currentFilter.find('.variant-size-active-container').last();
                    if ($lastContainer.length > 0) {
                      $lastContainer.after($newInactiveContainer.clone());
                    } else {
                      $title.after($newInactiveContainer.clone());
                    }
                  }
                } else {
                  // If no title found, just append containers
                  if ($newActiveContainer.length > 0) {
                    $currentFilter.append($newActiveContainer.clone());
                  }
                  if ($newInactiveContainer.length > 0) {
                    $currentFilter.append($newInactiveContainer.clone());
                  }
                }
              } else {
                // For body filter, replace the filter content inside grid-uniform
                var $gridUniform = $currentFilter.find('.grid-uniform[data-prefix="variant-size"]');
                if ($gridUniform.length > 0) {
                  var $newGridUniform = $newFilter.find('.grid-uniform[data-prefix="variant-size"]');
                  if ($newGridUniform.length > 0) {
                    $gridUniform.html($newGridUniform.html());
                  }
                } else {
                  // If no grid-uniform, replace the entire filter
                  $currentFilter.replaceWith($newFilter.clone());
                }
              }
            } else {
              console.warn('VariantFilter: Current filter not found in DOM');
            }
          } else {
            console.warn('VariantFilter: Filter not found in AJAX response');
          }
          
          _obj.find('.active-filter').length == 0 && $('#clear-all-filter').addClass('hidden');
          $('.new-loading').removeClass('loading');
          AT_Main.filterCatalog();
          AT_Main.fixButton();
          AT_Main.fixTitle();
          AT_Main.handleReviews();
          AT_Main.switchImgProduct();
          AT_Main.handleGridList();
          AT_Main.init_CountDown();
          AT_Main.currenciesFormat("#col-main .money");
          // Trigger variant filter update after AJAX filter (for color filter integration)
          setTimeout(function() {
            $(document).trigger('filterUpdated');
          }, 100);
        },
        error: function(e) {
          $('.new-loading').removeClass('loading');
          console.log(e);
        },

			});


		},

	}
})(jQuery);

$(document).ready(function(){
	AT_Filter.init();
});